import React from "react";
import { Typography } from "@mui/material";
import Grid2 from "@mui/material/Grid2";

import { Person } from "api/Community/CommunityInterfaces";
import EditableFieldsTable from "components/Records/RecordDisplay/EditableFieldsTable";
import PersonDiscipleshipStageCard from "components/PersonDiscipleshipStageCard";

import TabPanel from "./TabPanel";
import ReligionMultiStageSelector from "./ReligionMultistageSelector";

interface Props {
  tabIndex: number;
  index: number;

  data: Person;

  onUpdate: (id: number, field: keyof Person, value: any) => Promise<void>;
  setData: React.Dispatch<React.SetStateAction<Person | null>>;
}

const PeopleReligiousInfoTab: React.FC<Props> = ({
  tabIndex,
  index,
  data,
  onUpdate,
  setData,
}) => {
  return (
    <TabPanel value={tabIndex} index={index}>
      <Grid2 container>
        <Grid2 size={6}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                Religious Details
            </Typography>

            {/* Religion Classifications */}
            <ReligionMultiStageSelector
            label="Religion (Self Identified)"
            value={data.religion_self_identified}
            onChange={(ids) => onUpdate(data.id, "religion_self_identified_ids" as any, ids)}
            />

            <ReligionMultiStageSelector
            label="Religion (User Identified)"
            value={data.religion_user_identified}
            onChange={(ids) => onUpdate(data.id, "religion_user_identified_ids" as any, ids)}
            />



          <EditableFieldsTable<Person>
            record={data}
            onSave={(field, value) => onUpdate(data.id, field, value)}
            fields={[
              { field: "place_of_worship", label: "Place of Worship" },
              { field: "baptized", label: "Baptized", type: "boolean" },
              { field: "baptism_date", label: "Baptism Date", type: "date" },
              { field: "confirmation_date", label: "Confirmation Date", type: "date" },
              {
                field: "first_communion_date",
                label: "First Communion Date",
                type: "date",
              },
            ]}
          />
        </Grid2>

        <Grid2 size={6}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
            Discipleship Stage
          </Typography>

          <PersonDiscipleshipStageCard
            person={data}
            onPersonUpdated={(updated) => {
              setData((prev) => ({ ...prev!, ...updated }));
            }}
            stageDetailPath={() => `/community/discipleship-pathway/`}
          />
        </Grid2>
      </Grid2>
    </TabPanel>
  );
};

export default PeopleReligiousInfoTab;
